package com.wintermar.inspection.feature.domain.model

data class VesselModel(
    val id: String = "",
    val name: String = ""
)
